import { RootRoute } from '@app/const';
import { isValueOf } from '../object';

/**
 * Read active route from URL hash, falling back to @see RootRoute.canvas.
 *
 * @note @see AppLayout cleans up the hash when it is invalid.
 */
export function getRootRoute(): RootRoute {
  const rootRoute = location.hash.slice(1);
  return (isValueOf(RootRoute, rootRoute)) ? rootRoute : RootRoute.canvas;
}
